import React from "react";

// Assets
import "~/assets/sass/pages/invest/IrModal/product.scss";
import { AREA_TYPE, IP_TYPE } from "~/constant/ApplyFormConstant";
import { thousandFormatter } from "~/utils/formatter";
import { Trans, useTranslation } from "react-i18next";

const ProductView = ({ irProduct }) => {
	const { t } = useTranslation();

	return (
		<>
			{/*제품기술시장 view*/}
			<div className="product-view">
				<div className="data-form">
					<section>
						<div className="section-title">
							{t(
								"pages.investment.InvestEvalPage.detail.modal.product.section1.title"
							)}
						</div>
						<div className="c__form vertical sub-section">
							<div className="f__group">
								<label className="f__label">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.product.section1.label01"
									)}
								</label>
								<div className="f__control">
									<textarea
										className="c__textarea f__item"
										value={irProduct?.description}
										readOnly
									/>
								</div>
							</div>
							<div className="f__group">
								<label className="f__label">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.product.section1.label02"
									)}
								</label>
								<div className="f__control">
									<textarea
										className="c__textarea f__item"
										value={irProduct?.differentiation}
										readOnly
									/>
								</div>
							</div>
						</div>
						<div className="c__form vertical sub-section">
							<div className="f__group">
								<div className="f__label unit-wrap">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.product.section1.label03"
									)}{" "}
									<span className="unit">
										{t(
											"pages.investment.InvestEvalPage.detail.modal.basicInfo.section3.label03-1"
										)}
									</span>
								</div>
								{irProduct?.IRProductCustomer?.map((d) => (
									<ul className="f__control" key={d.idx}>
										<li className="kind-select">{AREA_TYPE[d.area]}</li>
										<li className="content customer-content">{d.content}</li>
										<li className="number">{thousandFormatter(d.value)}</li>
										<li className="customer-ratio">{d.ratio}</li>
									</ul>
								))}
							</div>
						</div>
					</section>
					<section>
						<div className="section-title">
							{t(
								"pages.investment.InvestEvalPage.detail.modal.product.section2.title"
							)}
						</div>
						<div className="c__form vertical sub-section">
							<div className="f__group">
								<label className="f__label">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.product.section2.label01"
									)}
								</label>
								<div className="f__control">
									<textarea
										className="c__textarea f__item"
										value={irProduct?.mainTech}
										readOnly
									/>
								</div>
							</div>
							<div className="f__group">
								<label className="f__label">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.product.section2.label02"
									)}
								</label>
								<div className="f__control">
									<textarea
										className="c__textarea f__item"
										value={irProduct?.advantages}
										readOnly
									/>
								</div>
							</div>
						</div>
						<div className="c__form vertical sub-section">
							<div className="f__group">
								<div className="f__label">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.product.section2.label03"
									)}
								</div>
								{irProduct?.IRProductIp?.map((d) => (
									<ul className="f__control" key={d.idx}>
										<li className="kind-select">{IP_TYPE[d.type]}</li>
										<li className="content">{d.content}</li>
										<li className="number">
											<Trans
												i18nKey="pages.investment.InvestEvalPage.detail.modal.product.section2.label03-1"
												components={[{ d }]}
											/>
										</li>
										<li className="ipr-date">{d.date.substring(0, 10)}</li>
									</ul>
								))}
							</div>
						</div>
					</section>
					<section>
						<div className="section-title">
							{t(
								"pages.investment.InvestEvalPage.detail.modal.product.section3.title"
							)}
						</div>
						<div className="c__form vertical sub-section">
							<div className="f__group">
								<label className="f__label">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.product.section3.label01"
									)}
								</label>
								<div className="f__control">
									<textarea
										className="c__textarea f__item"
										value={irProduct?.marketResearch}
										readOnly
									/>
								</div>
							</div>
							<div className="f__group">
								<label className="f__label">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.product.section3.label02"
									)}
								</label>
								<div className="f__control">
									<textarea
										className="c__textarea f__item"
										value={irProduct?.positioning}
										readOnly
									/>
								</div>
							</div>
						</div>
						<div className="c__form vertical sub-section">
							<div className="f__group">
								<div className="f__label unit-wrap">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.product.section3.label03"
									)}
									<span className="unit">
										{t(
											"pages.investment.InvestEvalPage.detail.modal.basicInfo.section3.label03-1"
										)}
									</span>
								</div>
								{irProduct?.IRProductMarket?.map((d) => (
									<ul className="f__control" key={d.idx}>
										<li className="kind-select">{AREA_TYPE[d.area]}</li>
										<li className="content">{d.content}</li>
										<li className="number">{thousandFormatter(d.value)}</li>
									</ul>
								))}
							</div>
						</div>
						<div className="c__form vertical sub-section">
							<div className="f__group">
								<div className="f__label unit-wrap">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.product.section3.label04"
									)}
									<span className="unit">
										{t(
											"pages.investment.InvestEvalPage.detail.modal.basicInfo.section3.label03-1"
										)}
									</span>
								</div>
								{irProduct?.IRProductPlayer?.map((d) => (
									<ul className="f__control" key={d.idx}>
										<li className="kind-select">{AREA_TYPE[d.area]}</li>
										<li className="name">{d.name}</li>
										<li className="content">{d.content}</li>
										<li className="number">{thousandFormatter(d.sales)}</li>
									</ul>
								))}
							</div>
						</div>
					</section>
				</div>
			</div>
		</>
	);
};

export default ProductView;
